import axios from 'axios'

export const getIq = (page, filter, itemPerPage) => {
  return axios.get(`instant-request/${page}/${filter}/${itemPerPage}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getIqById = (id) => {
  return axios.get(`instant-request/${id}/details`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const editIq = (id, payload) => {
  return axios.put(`instant-request/${id}/details`, payload)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getQuotationDocument = ({id, fileName}) => {
  return axios.get(`instant-request/${id}/invoice`, { responseType: 'blob' })
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/instant.api.js